import { render, staticRenderFns } from "./stopSellingAction.vue?vue&type=template&id=f387f954&scoped=true"
import script from "./stopSellingAction.vue?vue&type=script&lang=js"
export * from "./stopSellingAction.vue?vue&type=script&lang=js"
import style0 from "./stopSellingAction.vue?vue&type=style&index=0&id=f387f954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f387f954",
  null
  
)

export default component.exports